import React from 'react';
import { motion } from 'framer-motion';
import styles from './ModernSection.module.css';

const ModernSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className={styles.modernSection}>
      <div className={styles.container}>
        
        {/* Company Factsheet - TODO: Work on this section tomorrow */}
      </div>
    </section>
  );
};

export default ModernSection;
